import { useMemo } from 'react'
import { CODEX_CATEGORIES } from '../../data/codexEntries'

function CodexEditorForm({
  draft,
  validationErrors,
  onChange,
  onAddBlock,
  onDeleteBlock,
  onTemplate
}) {
  const blockOptions = useMemo(
    () => [
      { id: 'heading', label: 'Titre' },
      { id: 'paragraph_markdown', label: 'Paragraphe' },
      { id: 'callout', label: 'Encadré' },
      { id: 'example_music', label: 'Exemple musical' },
      { id: 'image', label: 'Image' },
      { id: 'divider', label: 'Séparateur' }
    ],
    []
  )

  if (!draft) return <div className="codex-admin-empty">Sélectionne ou crée une fiche.</div>

  return (
    <section className="codex-admin-editor">
      {validationErrors.length > 0 && (
        <div className="codex-admin-errors">
          {validationErrors.map((e, i) => <p key={i}>{e}</p>)}
        </div>
      )}
      <div className="codex-admin-grid">
        <label>Titre
          <input value={draft.title || ''} onChange={(e) => onChange('title', e.target.value)} />
        </label>
        <label>Description courte
          <input value={draft.shortDescription || ''} onChange={(e) => onChange('shortDescription', e.target.value)} />
        </label>
        <label>Catégorie
          <select value={draft.category || 'parcours'} onChange={(e) => onChange('category', e.target.value)}>
            {Object.keys(CODEX_CATEGORIES).map((k) => <option key={k} value={k}>{CODEX_CATEGORIES[k]}</option>)}
          </select>
        </label>
        <label>Ordre
          <input type="number" value={draft.order ?? 999} onChange={(e) => onChange('order', Number(e.target.value || 999))} />
        </label>
      </div>

      <div className="codex-admin-template-row">
        <button type="button" onClick={() => onTemplate('theorie')}>Template théorie</button>
        <button type="button" onClick={() => onTemplate('style')}>Template style</button>
        <button type="button" onClick={() => onTemplate('compositeur')}>Template compositeur</button>
        <button type="button" onClick={() => onTemplate('forme')}>Template forme</button>
      </div>

      <div className="codex-admin-blocks">
        {(draft.contentBlocks || []).map((block, idx) => (
          <div className="codex-admin-block" key={`${block.type}-${idx}`}>
            <div className="codex-admin-block-header">
              <strong>{block.type}</strong>
              <button type="button" onClick={() => onDeleteBlock(idx)}>Supprimer</button>
            </div>
            {block.type !== 'divider' && (
              <textarea
                value={block.text || ''}
                onChange={(e) => {
                  const next = [...(draft.contentBlocks || [])]
                  next[idx] = { ...next[idx], text: e.target.value }
                  onChange('contentBlocks', next)
                }}
                rows={block.type === 'example_music' ? 6 : 4}
              />
            )}
            {block.type === 'image' && (
              <>
                <input
                  placeholder="URL image"
                  value={block.url || ''}
                  onChange={(e) => {
                    const next = [...(draft.contentBlocks || [])]
                    next[idx] = { ...next[idx], url: e.target.value }
                    onChange('contentBlocks', next)
                  }}
                />
                <input
                  placeholder="Légende"
                  value={block.caption || ''}
                  onChange={(e) => {
                    const next = [...(draft.contentBlocks || [])]
                    next[idx] = { ...next[idx], caption: e.target.value }
                    onChange('contentBlocks', next)
                  }}
                />
              </>
            )}
          </div>
        ))}
      </div>

      <div className="codex-admin-add-row">
        {blockOptions.map((b) => (
          <button key={b.id} type="button" onClick={() => onAddBlock(b.id)}>+ {b.label}</button>
        ))}
      </div>
    </section>
  )
}

export default CodexEditorForm
